"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = require("./Modal");
exports.Modal = Modal_1.default;
var useModal_1 = require("./hooks/useModal");
exports.useModal = useModal_1.default;
//# sourceMappingURL=index.js.map